import { Routes, Route } from 'react-router-dom';
import { ArcheLayout } from '../../../components/ArcheLayout';
import { StorageBrowsePage } from '../../shared/storage';
import { api } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';
import type { StorageArcheConfig } from '../../shared/storage';

const config: StorageArcheConfig = {
  title: 'Litcraft Addressables',
  requiredRole: 'litcraft_admin',
  accessDeniedMessage:
    'You need admin or litcraft_admin permissions to access Litcraft Addressables.',
  queryKeyNamespace: queryKeys.litcraftAddressables.all,
  api: api.litcraftAddressablesStorage,
  acceptedFileTypes: '.bundle,.json,.hash,image/*',
};

export function LitcraftAddressablesArchePage() {
  return (
    <ArcheLayout>
      <Routes>
        <Route path="/*" element={<StorageBrowsePage config={config} />} />
      </Routes>
    </ArcheLayout>
  );
}
